import PropTypes from 'prop-types';
import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import styles from './Sidebar2.module.css';
import { useProfile } from '../../../Providers/ProfileProvider';

export default function NavItem2({
  path,
  label,
  Logo,
}) {
  const params = useParams();
  const { profile } = useProfile();
  const location = useLocation();
  const selected = !!params?.currentWorkspace || (params?.id === profile?.config?.currentWorkspace);
  return (
    <li>
      <Link to={path} className={`${styles.navLink} ${selected ? styles.navLinkSelected : ''} ${location.pathname === `/${label}` ? styles.background : ''}`}>

        <div
          className={`${styles.navLogos} ${selected ? styles.navLinkSelectedLogo : ''}`}
        >
          <Logo style={{ color: selected ? 'var(--color-accent)' : 'var(--color-text-secondary)' }} fill={selected ? 'var(--color-accent)' : 'none'} />
        </div>
        <p style={{
          marginLeft: 'var(--space-xs)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '150px',
          color: selected ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
        }}
        >
          {label}
        </p>
      </Link>
    </li>
  );
}

NavItem2.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  Logo: PropTypes.object.isRequired,
};
